/**
 * Metadato para filtros y configuraciones
 */
export default class Metadato {
  /** @type {String?} */ campo = null
  /** @type {Number?} */ operador = null
  /** @type {String?} */ valor = null
}
